import * as actionTypes from "./actionTypes";

const initialState = {
  allTableDetails: {
    loading: false,
    selectedRecallsId: [],
    data: {}
  }
};

const getRecallAllTableStart = (state) => ({
  ...state,
  allTableDetails: {
    ...state.allTableDetails,
    loading: true,
    selectedRecallsId: []
  }
});

const getRecallAllTableSuccess = (state, action) => ({
  ...state,
  allTableDetails: {
    ...state.allTableDetails,
    loading: false,
    data: action.data
  }
});
const getRecallAllTableFail = (state) => ({
  ...state,
  allTableDetails: {
    loading: false
  }
});

const setCheckbox = (state, action) => ({
  ...state,
  allTableDetails: {
    ...state.allTableDetails,
    selectedRecallsId: action.id
  }
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_RECALL_ALL_TABLE_START:
      return getRecallAllTableStart(state, action);

    case actionTypes.FETCH_RECALL_ALL_TABLE_SUCCESS:
      return getRecallAllTableSuccess(state, action);

    case actionTypes.FETCH_RECALL_ALL_TABLE_FAIL:
      return getRecallAllTableFail(state, action);

    case actionTypes.SET_CHECKBOX:
      return setCheckbox(state, action);

    default:
      return state;
  }
};

export default reducer;
